var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"scroll-anchor",class:['scroll-anchor--type-' + _vm.type, 'scroll-anchor--value-' + _vm.value],style:({ top: _vm.offset })})
}
var staticRenderFns = []

export { render, staticRenderFns }